module.exports = __webpack_public_path__ + "img/mecene-et-loire.76a8d785.jpg";